import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { STAYS } from "../data/content";

export const Stays = ({ onEnquire }) => {
  return (
    <section
      id="stays"
      data-testid="stays-section"
      className="bg-[#EFECE4] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <p className="uppercase text-xs tracking-[0.25em] text-[#C4A575] font-semibold">
              Premium Stays
            </p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-primary mt-4 leading-tight max-w-xl">
              Sleep above the clouds, dine beneath the stars
            </h2>
          </div>
          <button
            onClick={onEnquire}
            data-testid="stays-enquire-button"
            className="self-start flex items-center gap-2 text-sm uppercase tracking-[0.16em] text-primary border-b border-primary pb-1 hover:gap-3 transition-all"
          >
            View packages <ArrowUpRight size={16} />
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {STAYS.map((stay, i) => (
            <motion.div
              key={stay.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              className="group bg-[#F6F5F0] border border-border/50 overflow-hidden"
              data-testid={`stay-card-${i}`}
            >
              <div className="relative h-72 overflow-hidden">
                <img
                  src={stay.image}
                  alt={stay.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1.2s]"
                />
                <span className="absolute top-4 left-4 bg-[#243E2C]/90 text-[#EFECE4] text-[10px] uppercase tracking-[0.18em] px-3 py-1.5">
                  {stay.tag}
                </span>
              </div>
              <div className="p-7">
                <h3 className="font-serif text-2xl text-primary">{stay.name}</h3>
                <p className="text-sm text-text-muted mt-3 leading-relaxed" style={{ color: "#5A655E" }}>
                  {stay.desc}
                </p>
                <button
                  onClick={onEnquire}
                  className="mt-6 flex items-center gap-2 text-xs uppercase tracking-[0.16em] text-primary group-hover:text-[#C4A575] transition-colors"
                >
                  Enquire <ArrowUpRight size={14} />
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
